import React, { useEffect } from 'react'
import waveBg from '../../assets/img/auth-wave-bg.png'
import logo from '../../assets/img/image-1@2x.png'
import helpIcon from '../../assets/img/Help-Icon.svg'
import { Navigate, Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getOrganizations } from '../../actions/organizations'

const AuthLayout = () => {

  const { token, role } = useSelector(state => state.auth)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getOrganizations())
  }, [])


  if (!!token) return <Navigate to={`/${role}`} replace />


  return (
    <div className="relative min-h-screen bg-[#f9fafb] font-[Inter] overflow-hidden">
      <img
        src={waveBg}
        alt=""
        aria-hidden="true"
        className="pointer-events-none select-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[120rem] h-[64rem] max-w-none object-bottom hidden md:block"
      />

      <div className="relative z-[1] flex min-h-screen flex-col items-center px-4 sm:px-6 py-8 lg:py-12">
        <img
          src={logo}
          alt=""
          className="h-[3.5rem] w-auto sm:h-[5rem] object-contain"
        />

        <h1 className="mt-6 sm:mt-8 m-0 max-w-[74rem] text-center text-[1.25rem] sm:text-[1.5rem] lg:text-[2rem] font-semibold text-[#111827]">
          Система регистрации и ведения результатов олимпиад и конкурсов
        </h1>
        <p className="mt-2 m-0 max-w-[30.75rem] text-center text-[0.938rem] sm:text-[1.125rem] lg:text-[1.25rem] text-[#111827]">
          довузовских общеобразовательных организаций
        </p>

        <div className="mt-8 lg:mt-12 flex w-full justify-center">
          <Outlet />
        </div>

        <div className="mt-10 lg:fixed lg:right-[1.5rem] lg:bottom-[2.25rem] lg:mt-0 flex w-full max-w-[21.75rem] items-center gap-[1rem] rounded-[10px] bg-[#f8fafc] p-[1.25rem] lg:p-[1.5rem]">
          <img
            src={helpIcon}
            alt=""
            className="h-[2.5rem] w-[2.5rem] shrink-0 rounded-[10px]"
          />
          <div className="flex flex-col gap-[0.312rem]">
            <div className="text-[0.938rem] sm:text-[1rem] font-medium text-[#171717]">Нужна помощь?</div>
            <div className="text-[0.812rem] sm:text-[0.875rem] text-[#848484]">Свяжитесь с поддержкой</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AuthLayout
